///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { GtthAccessDeniedModalService } from '../access-denied/accessdenied.service';
import { Principal } from './principal.service';

export const canActivateUser: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const principal = inject(Principal);
    const accessDeniedService = inject(GtthAccessDeniedModalService);
    const authorities = route.data.authorities;

    await principal.identity();
    const hasAuthority = await principal.hasAnyAuthority(authorities);

    if (!hasAuthority) {
        accessDeniedService.open();
    }

    return hasAuthority;
};
